








import { Component, Vue, Prop } from "vue-property-decorator";
import EditWord from "@/components/modals/words/EditWord.vue";

@Component({
  components: { EditWord },
})
export default class SingleWordLevelCard extends Vue {
  @Prop() level!: any;
  wordIndex: any = -1;
  show = false;
  @Prop() index!: any;
  @Prop() dayOfTheWords!: any;
  Categories: any;
  currentRoute: any;
  levelId = 1;
  get currentRouteName() {
    return this.$route.name;
  }
  DeleteConversation(id: any, index: any) {
    const d = "";
  }
  showPopup(word: any, index: any) {
    alert(index);
    this.wordIndex = index;
    this.show = true;
  }
}
